import { render, staticRenderFns } from "./PhotoModal.vue?vue&type=template&id=d1053858&scoped=true"
import script from "./PhotoModal.vue?vue&type=script&lang=js"
export * from "./PhotoModal.vue?vue&type=script&lang=js"
import style0 from "./PhotoModal.vue?vue&type=style&index=0&id=d1053858&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1053858",
  null
  
)

export default component.exports